"use client";
import { t as cn } from "../chunks/cn-dk9nmc4mhy1765ud.js";
import { t as Container } from "../chunks/container-bmokyww153ys88nc.js";
import React from "react";
import { jsx } from "react/jsx-runtime";
//#region src/components/grid/grid.tsx
/**
* CSS grid container. Applies `display: grid` by default; pass `className`
* to set columns, rows, gap, and any other grid utilities. Conflicting user
* classes win via `tailwind-merge`.
*
* @example
* ```tsx
* <Grid className="grid-cols-3 gap-4">…</Grid>
* <Grid className="grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">…</Grid>
* ```
*/
var Grid = React.forwardRef(({ className, children, ...props }, ref) => {
	return /* @__PURE__ */ jsx(Container, {
		ref,
		className: cn("grid", className),
		...props,
		children
	});
});
Grid.displayName = "Grid";
//#endregion
export { Grid };

